import React, { useEffect, useState } from 'react';
import FormInputField from 'src/components/common/formInputField';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import { Link, useParams } from 'react-router-dom';
import Editor from 'src/components/Editor';
import { useCourseActions } from 'src/store/course/actions';
import { useDispatch, useSelector } from 'react-redux';
import { SelectModel } from 'src/models/videosModel';
import { RootState } from 'src/store/reducers/state';
import { useChannelActions } from 'src/store/channel/actions';
import { useCategoryActions } from 'src/store/category/actions';
import UploadThumbnail from '../components/UploadThumbnail';
import { useNavigate } from 'react-router-dom';
import Content from './components/Content';
import ToastMessage from 'src/components/ToastContainer';
import { successMsg, errorMsg } from 'src/components/utilities/utils';
import { useVideosActions } from 'src/store/videos/actions';
import { ImageStringConverter } from 'src/components/utilities/utils';
import VideoContentTypeModal from 'src/components/admin/videos/components/VideoContentTypeModal';
import { customFilterOption } from 'src/components/utilities/utils';
import { useUserActions } from 'src/store/users/actions';
import AddSpeaker from '../../videos/addSpeaker';
import AddChapterModel from './components/AddChapterModel';
import AddCheckpointModel from './components/AddCheckpointModel';
import { useSettingActions } from 'src/store/settings/actions';
const showApiError = (msg: string) => {
  errorMsg(msg);
};
const CourseTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams<string>();
  const courseActions = useCourseActions(dispatch);
  const channelActions = useChannelActions(dispatch);
  const settingAction = useSettingActions(dispatch);
  const videoActions = useVideosActions(dispatch);
  const userAction = useUserActions(dispatch);
  const categoryActions = useCategoryActions(dispatch);
  const [editorState, setEditorState] = useState<string>('');
  const [isEditorDirty, setIsEditorDirty] = useState<boolean>(false);
  const [price, setPrice] = useState<number>();
  const [finalChannels, setFinalChannels] = useState<SelectModel[]>();
  const [finalContent, setFinalContent] = useState<SelectModel[]>();
  const [step, setStep] = useState<number>(1);
  const [showError, setShowError] = useState<boolean>(false);
  const [publishStatus, setPublishStatus] = useState<number>(1);
  const [speakerName, setSelectedSpeakerName] = useState<string>();
  const [courseId, setCourseId] = useState<string>('');
  const [newChannelId, setNewChannelId] = useState<string>('');
  const [isVideoContentTypeModalOpen, setIsVideoContentTypeModalOpen] = useState<boolean>(false);
  const [role, setRole] = useState<string>('');
  const [finalSpeaker, setFinalSpeaker] = useState<SelectModel[]>();
  const [checkpointAddFlag, setCheckpointAddFlag] = useState<string>('Add');
  const [chapterAddFlag, setChapterAddFlag] = useState<string>('Add');
  const [paymentGateway, setPaymentGateway] = useState<string>('Primary');
  const [selectedCertificateTemplate, setSelectedCertificateTemplate] = useState<string>('');
  const [copiedUrl, setCopiedUrl] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    control,
    setValue,
    watch,
    getValues,
    trigger,
  } = useForm();
  const channelId = watch('channelId');
  const courseType = watch('type');
  const completionRequirement = watch('courseCompletionType');
  const handleNextClick = async () => {
    const isValid = await trigger(['contentTypes', 'categories']);
    if (isDirty || isEditorDirty) {
      const result = await handleSubmit(onSubmit)();
      setIsEditorDirty(false);
    }
    if (!isValid) return;
    if (channelId || courseType == 2) {
      if (courseType == 2) {
        // For type == 2
        if (step === 5 && !id) {
          setStep((x) => x + 2); // Skip Content for type == 2 without id
        } else {
          setStep((x) => x + 1);
        }
      } else {
        // For type != 2
        if (step === 4 && !id) {
          setStep((x) => x + 2); // Skip Content for type == 1 without id
        } else {
          setStep((x) => x + 1);
        }
      }
    } else {
      if (courseType != 2) {
        setShowError(true);
      }
    }
  };

  const handleCopyUrl = () => {
    if (singleCourse?.courseUrl) {
      navigator.clipboard.writeText(singleCourse.courseUrl);
      setCopiedUrl(true);
      setTimeout(() => setCopiedUrl(false), 2000);
    }
  };

  const handlePreviousClick = () => {
    if (courseType == 2) {
      // For type == 2
      if (!id && step === 7) {
        setStep((x) => x - 2); // Skip Content for type == 2 without id
      } else {
        setStep((x) => x - 1);
      }
    } else {
      // For type != 2
      if (!id && step === 6) {
        setStep((x) => x - 2); // Skip Content for type == 1 without id
      } else {
        setStep((x) => x - 1);
      }
    }
  };

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    const finalData = userData && JSON.parse(userData);
    setRole(finalData?.role);
  }, []);

  const {
    mediaUrl,
    channelList,
    contentType,
    singleCourse,
    courseCreditType,
    courseModule,
    singleChannel,
    isCourseSaved,
    isCourseUpdated,
    courseVideos,
    message,
    categoriesList,
    speakers,
    roles,
    memberId,
    productAccess,
    certificateTemplates,
    savedCourseId
  } = useSelector((state: RootState) => {
    return {
      mediaUrl: state.videos.mediaUrl,
      channelList: state.channel.channelList,
      contentType: state.category.contentType,
      singleCourse: state.course.singleCourse,
      courseCreditType: state.course.courseCreditType,
      courseModule: state.course.courseModule,
      singleChannel: state.channel.singleChannel,
      isCourseSaved: state.course.isCourseSaved,
      isCourseUpdated: state.course.isCourseUpdated,
      courseVideos: state.course.courseVideos,
      message: state.course.message,
      categoriesList: state.category.categoriesList,
      speakers: state.videos.speakers,
      roles: state.users.roles,
      memberId: state.videos.memberId,
      productAccess: state.videos.isProductAccess,
      certificateTemplates: state.setting.certificateTemplates,
      savedCourseId: state.course.savedCourseId
    };
  });

  useEffect(() => {
    if (memberId) {
      setValue('speakers', [...getValues('speakers'), { value: memberId, label: speakerName }]);
      const speakerId = roles && roles.filter((role) => role.name.toUpperCase() === 'SPEAKER');
      if (speakerId && speakerId.length) {
        videoActions.getSpeakersRequest(speakerId[0]?.id);
      }
    }
  }, [memberId, getValues]);

  useEffect(() => {
    if (singleCourse && Object.keys(singleCourse).length) {
      videoActions.getMediaUrlRequest(singleCourse.description);
    }
  }, [singleCourse]);

  useEffect(() => {
    categoryActions.getCategoriesListRequest();
    userAction.getRolesRequest();
  }, []);

  useEffect(() => {
    if (speakers) {
      const finalspeaker = speakers.map((speaker) => {
        return { value: speaker.id, label: `${speaker.firstName} ${speaker.lastName}` };
      });
      setFinalSpeaker(finalspeaker);
    }
  }, [speakers]);

  useEffect(() => {
    if (mediaUrl) {
      setEditorState(mediaUrl);
    }
  }, [mediaUrl]);

  useEffect(() => {
    if (channelList && channelList.length) {
      const options = channelList.map((item) => ({
        value: item.id,
        label: item.displayText
      }));
      const finalChannels = [{ value: '', label: 'Select...' }, ...options];
      setFinalChannels(finalChannels);
    }
  }, [channelList]);

  useEffect(() => {
    if (contentType) {
      const finalData = contentType.map((contentType) => {
        return { value: contentType.id, label: contentType.contentType };
      });
      const finalContentType = [{ value: '', label: 'Select...' }, ...finalData];
      setFinalContent(finalContentType);
    }
  }, [contentType]);

  useEffect(() => {
    if (roles && roles.length) {
      const speakerId = roles.filter((role) => role.name.toUpperCase() === 'SPEAKER');
      if (speakerId && speakerId.length) {
        videoActions.getSpeakersRequest(speakerId[0]?.id);
      }
    }
  }, [roles]);

  const inheritPrice = watch('inheritPrice');

  useEffect(() => {
    if (inheritPrice) {
      setValue(
        'price',
        singleChannel && (singleChannel.channelCost < 0 || singleChannel.channelCost == null)
          ? 0
          : singleChannel.channelCost
      );
    } else {
      setValue('price', singleCourse && singleCourse.price);
    }
  }, [inheritPrice]);

  useEffect(() => {
    const initialValue = singleCourse.inheritPrice;
    setValue('inheritPrice', initialValue);
  }, [setValue]);

  useEffect(() => {
    if (
      singleCourse &&
      Object.keys(singleCourse).length &&
      singleChannel &&
      Object.keys(singleChannel)
    ) {
      singleCourse.inheritPrice &&
        setValue(
          'price',
          singleChannel.channelCost < 0 || singleChannel.channelCost == null
            ? 0
            : singleChannel.channelCost
        );
    }
  }, [singleCourse, singleChannel]);

  const onSubmit = (data: any) => {
    const toIds = (list: any) =>
      Array.isArray(list) ? list.map((item: any) => item.value) : [];

    const categories = toIds(data.categories);
    const speakers = toIds(data.speakers);
    if (data.type == 2 && !id) {
      const authHeaders = {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      };

      const createCourseWithChannel = async () => {
        try {
          // 1. Create channel
          const channelResponse = await fetch(`${process.env.REACT_APP_BASE_API_URL}/v2/channel`, {
            method: 'POST',
            headers: authHeaders,
            body: JSON.stringify({ name: data.title, courseType: data.type })
          });
          const channelResult = await channelResponse.json();

          if (!channelResponse.ok || !channelResult?.result?.id) {
            if (channelResponse.status === 409 || channelResult?.statusCode === 409) {
              showApiError('Course creation failed. A channel with the same name already exists. Please choose a different course name.');
            } else {
              showApiError('Unable to create the course. Please try again.');
            }
            return;
          }

          const channelId = channelResult.result.id;
          setNewChannelId(channelId);

          // 2. Create course
          const courseResponse = await fetch(`${process.env.REACT_APP_BASE_API_URL}/v2/courses`, {
            method: 'POST',
            headers: authHeaders,
            body: JSON.stringify({
              channelId,
              title: data.title,
              type: data.type,
              description: ImageStringConverter(editorState),
              contentTypes: data.contentTypes?.value ? data.contentTypes.value : '',
              categories: categories ? categories : [],
              speakers: speakers ? speakers : []
            })
          });
          const courseResult = await courseResponse.json();

          if (!courseResponse.ok || !courseResult?.result) {
            showApiError(courseResult?.message || 'Failed to create course. Please try again.');
            return;
          }

          setCourseId(courseResult.result);
          navigate(`/courseTab/${courseResult.result}`);
        } catch (error) {
          console.log('error', error);
          showApiError('Something went wrong. Please try again.');
        }
      };

      createCourseWithChannel();
    } else {
      const creditTypes = toIds(data.creditTypes);
      const modules = toIds(data.modules);
      if (id) {
        if (courseType == 2) {
          // For type == 2
          if (step === 1) {
            const payloadData = {
              id: id,
              patchJsonData: [
                { op: 'replace', path: 'title', value: data.title },
                { op: 'replace', path: 'type', value: data.type },
                { op: 'replace', path: 'channelId', value: data.channelId.value },
                { op: 'replace', path: 'contentTypes', value: data.contentTypes.value },
                { op: 'replace', path: 'categories', value: categories },
                { op: 'replace', path: 'speakers', value: speakers },
                { op: 'replace', path: 'description', value: ImageStringConverter(editorState) }
              ]
            };
            courseActions.updateCourseRequest(payloadData);
          } else if (step === 3) {
            const payloadData = {
              id: id,
              patchJsonData: [
                { op: 'replace', path: 'inheritPrice', value: inheritPrice },
                { op: 'replace', path: 'accessType', value: data.accessType },
                {
                  op: 'replace',
                  path: 'isSecondaryPaymentGateway',
                  value: paymentGateway === 'Secondary'
                },
                ...(inheritPrice ? [] : [{ op: 'replace', path: 'price', value: data.price }])
              ]
            };
            courseActions.updateCourseRequest(payloadData);
          } else if (step === 4) {
            const payloadData = {
              id: id,
              patchJsonData: [
                { op: 'replace', path: 'points', value: data.points },
                { op: 'replace', path: 'creditTypes', value: creditTypes },
                { op: 'replace', path: 'modules', value: modules },
                { op: 'replace', path: 'courseCompletionType', value: data.courseCompletionType },
                { op: 'replace', path: 'numberOfAttempts', value: data.numberOfAttempts },
                { op: 'replace', path: 'creditValueIfFail', value: data.creditValueIfFail || null },
                {
                  op: 'replace',
                  path: 'courseCompletionPercentage',
                  value: data.courseCompletionPercentage
                }
              ]
            };
            courseActions.updateCourseRequest(payloadData);
          } else if (step === 5) {
            const payloadData = {
              id: id,
              patchJsonData: [
                { op: 'replace', path: 'displayCourseProgress', value: data.displayCourseProgress },
                { op: 'replace', path: 'showCourseCompletion', value: data.showCourseCompletion },
                { op: 'replace', path: 'mustCompleteVideos', value: data.mustCompleteVideos },
                { op: 'replace', path: 'withCertificate', value: data.withCertificate },
                { op: 'replace', path: 'certificatetemplateid', value: data.certificatetemplateid },
                { op: 'replace', path: 'externalLink', value: data.externalLink },
                {
                  op: 'replace',
                  path: 'courseCompletionMessage',
                  value: data.courseCompletionMessage
                }
              ]
            };
            courseActions.updateCourseRequest(payloadData);
          } else if (step === 7) {
            const payloadData = {
              id: id,
              patchJsonData: [
                { op: 'replace', path: 'status', value: publishStatus },
                { op: 'replace', path: 'title', value: data.title },
                { op: 'replace', path: 'type', value: data.type },
                { op: 'replace', path: 'channelId', value: data.channelId.value },
                { op: 'replace', path: 'contentTypes', value: data.contentTypes.value },
                { op: 'replace', path: 'categories', value: categories },
                { op: 'replace', path: 'speakers', value: speakers },
                { op: 'replace', path: 'description', value: ImageStringConverter(editorState) },
                { op: 'replace', path: 'points', value: data.points },
                { op: 'replace', path: 'creditTypes', value: creditTypes },
                { op: 'replace', path: 'modules', value: modules },
                { op: 'replace', path: 'courseCompletionType', value: data.courseCompletionType },
                { op: 'replace', path: 'numberOfAttempts', value: data.numberOfAttempts },
                { op: 'replace', path: 'creditValueIfFail', value: data.creditValueIfFail || null },
                {
                  op: 'replace',
                  path: 'courseCompletionPercentage',
                  value: data.courseCompletionPercentage
                },
                { op: 'replace', path: 'displayCourseProgress', value: data.displayCourseProgress },
                { op: 'replace', path: 'showCourseCompletion', value: data.showCourseCompletion },
                { op: 'replace', path: 'mustCompleteVideos', value: data.mustCompleteVideos },
                { op: 'replace', path: 'withCertificate', value: data.withCertificate },
                { op: 'replace', path: 'certificatetemplateid', value: data.certificatetemplateid },
                { op: 'replace', path: 'externalLink', value: data.externalLink },
                {
                  op: 'replace',
                  path: 'courseCompletionMessage',
                  value: data.courseCompletionMessage
                }
              ]
            };
            courseActions.updateCourseRequest(payloadData);
          }
        } else {
          // For type != 2
          if (step === 1) {
            const payloadData = {
              id: id,
              patchJsonData: [
                { op: 'replace', path: 'title', value: data.title },
                { op: 'replace', path: 'type', value: data.type },
                { op: 'replace', path: 'channelId', value: data.channelId.value },
                { op: 'replace', path: 'contentTypes', value: data.contentTypes.value },
                { op: 'replace', path: 'categories', value: categories },
                { op: 'replace', path: 'speakers', value: speakers },
                { op: 'replace', path: 'description', value: ImageStringConverter(editorState) }
              ]
            };
            courseActions.updateCourseRequest(payloadData);
          } else if (step === 2) {
            const payloadData = {
              id: id,
              patchJsonData: [
                { op: 'replace', path: 'inheritPrice', value: inheritPrice },
                ...(inheritPrice ? [] : [{ op: 'replace', path: 'price', value: data.price }])
              ]
            };
            courseActions.updateCourseRequest(payloadData);
          } else if (step === 3) {
            const payloadData = {
              id: id,
              patchJsonData: [
                { op: 'replace', path: 'points', value: data.points },
                { op: 'replace', path: 'creditTypes', value: creditTypes },
                { op: 'replace', path: 'modules', value: modules },
                { op: 'replace', path: 'courseCompletionType', value: data.courseCompletionType },
                { op: 'replace', path: 'numberOfAttempts', value: data.numberOfAttempts },
                { op: 'replace', path: 'creditValueIfFail', value: data.creditValueIfFail || null },
                {
                  op: 'replace',
                  path: 'courseCompletionPercentage',
                  value: data.courseCompletionPercentage
                }
              ]
            };
            courseActions.updateCourseRequest(payloadData);
          } else if (step === 4) {
            const payloadData = {
              id: id,
              patchJsonData: [
                { op: 'replace', path: 'displayCourseProgress', value: data.displayCourseProgress },
                { op: 'replace', path: 'showCourseCompletion', value: data.showCourseCompletion },
                { op: 'replace', path: 'mustCompleteVideos', value: data.mustCompleteVideos },
                { op: 'replace', path: 'withCertificate', value: data.withCertificate },
                { op: 'replace', path: 'certificatetemplateid', value: data.certificatetemplateid },
                { op: 'replace', path: 'externalLink', value: data.externalLink },
                {
                  op: 'replace',
                  path: 'courseCompletionMessage',
                  value: data.courseCompletionMessage
                }
              ]
            };
            courseActions.updateCourseRequest(payloadData);
          } else if (step === 6) {
            const payloadData = {
              id: id,
              patchJsonData: [
                { op: 'replace', path: 'status', value: publishStatus },
                { op: 'replace', path: 'title', value: data.title },
                { op: 'replace', path: 'type', value: data.type },
                { op: 'replace', path: 'channelId', value: data.channelId.value },
                { op: 'replace', path: 'contentTypes', value: data.contentTypes.value },
                { op: 'replace', path: 'categories', value: categories },
                { op: 'replace', path: 'speakers', value: speakers },
                { op: 'replace', path: 'description', value: ImageStringConverter(editorState) },
                { op: 'replace', path: 'points', value: data.points },
                { op: 'replace', path: 'creditTypes', value: creditTypes },
                { op: 'replace', path: 'modules', value: modules },
                { op: 'replace', path: 'courseCompletionType', value: data.courseCompletionType },
                { op: 'replace', path: 'numberOfAttempts', value: data.numberOfAttempts },
                { op: 'replace', path: 'creditValueIfFail', value: data.creditValueIfFail || null },
                {
                  op: 'replace',
                  path: 'courseCompletionPercentage',
                  value: data.courseCompletionPercentage
                },
                { op: 'replace', path: 'displayCourseProgress', value: data.displayCourseProgress },
                { op: 'replace', path: 'showCourseCompletion', value: data.showCourseCompletion },
                { op: 'replace', path: 'mustCompleteVideos', value: data.mustCompleteVideos },
                { op: 'replace', path: 'withCertificate', value: data.withCertificate },
                { op: 'replace', path: 'certificatetemplateid', value: data.certificatetemplateid },
                { op: 'replace', path: 'externalLink', value: data.externalLink },
                {
                  op: 'replace',
                  path: 'courseCompletionMessage',
                  value: data.courseCompletionMessage
                }
              ]
            };
            courseActions.updateCourseRequest(payloadData);
          }
        }
      } else {
        const payloadData = {
          ...data,
          channelId: data.channelId ? data.channelId.value : '',
          description: ImageStringConverter(editorState),
          creditTypes: creditTypes ? creditTypes : [],
          modules: modules ? modules : [],
          points: data.points ? data.points : 0,
          contentTypes: data.contentTypes.value ? data.contentTypes.value : '',
          status: publishStatus,
          courseCompletionPercentage: data.courseCompletionPercentage
            ? data.courseCompletionPercentage
            : 0,
          courseCompletionType: parseInt(data.courseCompletionType),
          numberOfAttempts: data.numberOfAttempts,
          creditValueIfFail: data.creditValueIfFail
        };
        courseActions.saveCourseRequest(payloadData);
      }
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');
    if (tab === 'content') {
      setStep(6);
      navigate(`/courseTab/${id}`, { replace: true });
    }
  }, [location.search]);

  useEffect(() => {
    channelActions.getChannelListRequest();
    categoryActions.getContentTypeRequest({ pageNumber: 1 });
    courseActions.getCourseCreditTypeRequest();
    courseActions.getCourseModuleRequest();
  }, []);

  useEffect(() => {
    if (id) {
      courseActions.getSingleCourseRequest(id);
    }
  }, []);

  useEffect(() => {
    if (singleCourse) {
      let creditTypesData;
      if (singleCourse.creditTypes) {
        creditTypesData = singleCourse.creditTypes.map((item: any) => {
          return {
            value: item.id,
            label: item.name
          };
        });
      }
      let modulesData;
      if (singleCourse.modules) {
        modulesData = singleCourse.modules.map((item: any) => {
          return {
            value: item.id,
            label: item.name
          };
        });
      }
      let categoriesData;
      if (singleCourse.categories) {
        categoriesData = singleCourse.categories.map((item: any) => {
          return {
            value: item.id,
            label: item.name
          };
        });
      }
      let speakerData;
      if (singleCourse.speakers) {
        speakerData = singleCourse.speakers.map((item: any) => {
          return {
            value: item.id,
            label: item.name
          };
        });
      }
      const data = {
        ...singleCourse,
        channelId: {
          value: singleCourse.channelId,
          label: singleCourse.channelName
        },
        creditTypes: creditTypesData,
        modules: modulesData,
        categories: categoriesData,
        speakers: speakerData,
        contentTypes: {
          value: singleCourse.contentTypes && singleCourse.contentTypes[0]?.id,
          label: singleCourse.contentTypes && singleCourse.contentTypes[0]?.name
        },
        inheritPrice: singleCourse.type === 1 ? true : singleCourse.inheritPrice,
        creditValueIfFail: singleCourse?.creditValueIfFail
          ? Number(singleCourse.creditValueIfFail).toFixed(2)
          : null
      };
      setPublishStatus(singleCourse.status);
      reset(data);
      setSelectedCertificateTemplate(singleCourse?.certificateTemplateId);
      setPaymentGateway(singleCourse.isSecondaryPaymentGateway ? 'Secondary' : 'Primary');
      setEditorState(singleCourse.description);
    }
  }, [singleCourse]);

  useEffect(() => {
    if (channelId && channelId.value) {
      setShowError(false);
      channelActions.getSingleChannelRequest(channelId.value);
    }
  }, [channelId]);

  useEffect(() => {
    if (inheritPrice) {
      if (singleChannel) {
        setPrice(singleChannel.channelCost);
      }
    } else {
      setPrice(singleCourse.price);
    }
  }, [singleChannel]);

  useEffect(() => {
    if (!id) {
      reset({});
      setEditorState('');
      setValue('channelId', '');
      setValue('contentTypes', '');
      setValue('creditTypes', '');
      setValue('modules', '');
      setValue('categories', '');
      setValue('speakers', '');
      setValue('type', 2);
      setPublishStatus(1);
      setSelectedCertificateTemplate('');
    }
  }, [id]);

  useEffect(() => {
    if (
      (isCourseSaved && !id) ||
      (isCourseUpdated && (courseType == 2 ? step === 7 : step === 6))
    ) {
      if (step === 6) {
        navigate(`/courses/course`);
      } else {
        navigate(`/courseTab/${savedCourseId ? savedCourseId : id}`);
        setStep(1);
      }
    }
  }, [isCourseSaved, isCourseUpdated]);

  useEffect(() => {
    if (id) {
      courseActions.getCourseVideosRequest(id);
    }
  }, [id]);

  useEffect(() => {
    if (isCourseUpdated) {
      courseActions.getSingleCourseRequest(id);
      courseActions.resetCourseStateRequest();
      successMsg('Success');
    }
  }, [isCourseUpdated]);

  useEffect(() => {
    if (message === 'Channel is already exists in other course.') {
      successMsg('Channel already exists in other course. Please select other channel');
      courseActions.resetCourseStateRequest();
    }
  }, [message]);

  useEffect(() => {
    if (!Object.keys(productAccess).length) {
      videoActions.getProductAccessRequest();
    }
  }, []);
  useEffect(() => {
    settingAction.getCertificateTemplatesRequest({});
  }, []);
  const watchCertificate = watch('withCertificate');
  return (
    <div>
      <ToastMessage />
      <>
        <div className="mb-8">
          <h2 className="font-semibold my-1">Add Course</h2>
          <ol className="breadcrumb">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/">Course</Link>
            </li>
            <li className="active">
              <strong>Add Course</strong>
            </li>
          </ol>
        </div>
        {id ? (
          <h1 className="font-bold text-lg mb-5">{singleCourse && singleCourse.title}</h1>
        ) : (
          <h1 className="font-bold text-lg mb-5">{watch('title')}</h1>
        )}
        {/* Mobile: pill tabs - only on small screens */}
        <div className="md:hidden overflow-x-auto pb-1 -mx-2 px-2">
          <div className="flex gap-3 min-w-max">
            {[
              { label: 'Course Info', s: 1 },
              ...(courseType == 2 ? [{ label: 'Styling', s: 2 }] : []),
              { label: 'Pricing', s: courseType == 2 ? 3 : 2 },
              { label: 'Education', s: courseType == 2 ? 4 : 3 },
              { label: 'Progress', s: courseType == 2 ? 5 : 4 },
              ...((courseType == 2 || id) ? [{ label: 'Content', s: courseType == 2 ? 6 : 5 }] : []),
              { label: 'Publish', s: courseType == 2 ? 7 : id ? 6 : 5 },
            ].map(({ label, s }) => (
              <button
                key={s}
                type="button"
                onClick={() => setStep(s)}
                className={`flex items-center gap-2 whitespace-nowrap px-3 py-1.5 rounded-full text-sm font-medium transition-all
          ${step === s
                    ? 'bg-green-500 text-white shadow'
                    : step > s
                      ? 'bg-green-100 text-green-700'
                      : 'bg-red-100 text-red-500'
                  }`}
              >
                <span className={`w-2 h-2 rounded-full flex-shrink-0 ${step === s ? 'bg-white' : step > s ? 'bg-green-500' : 'bg-red-400'}`} />
                {label}
              </button>
            ))}
          </div>
        </div>
        <div className="hidden md:flex justify-between">
          <div className="flex justify-center items-center flex-col">
            <div
              onClick={() => setStep(1)}
              className="w-6 h-6 bg-green-400 rounded-full cursor-pointer"></div>
            <h1 className={`${step === 1 ? 'font-bold' : ''}`}>Course Information</h1>
          </div>
          {courseType == 2 && (
            <div className="flex justify-center items-center flex-col">
              <div
                onClick={() => setStep(2)}
                className={`w-6 h-6 ${step >= 2 ? 'bg-green-400' : 'bg-red-400'
                  } rounded-full cursor-pointer`}></div>
              <h1 className={`${step === 2 ? 'font-bold' : ''}`}>Styling</h1>
            </div>
          )}
          <div className="flex justify-center items-center flex-col">
            <div
              onClick={() => setStep(courseType == 2 ? 3 : 2)}
              className={`w-6 h-6 ${step >= (courseType == 2 ? 3 : 2) ? 'bg-green-400' : 'bg-red-400'
                } rounded-full cursor-pointer`}></div>
            <h1 className={`${step === (courseType == 2 ? 3 : 2) ? 'font-bold' : ''}`}>Pricing</h1>
          </div>
          <div className="flex justify-center items-center flex-col">
            <div
              onClick={() => setStep(courseType == 2 ? 4 : 3)}
              className={`w-6 h-6 ${step >= (courseType == 2 ? 4 : 3) ? 'bg-green-400' : 'bg-red-400'
                } rounded-full cursor-pointer`}></div>
            <h1 className={`${step === (courseType == 2 ? 4 : 3) ? 'font-bold' : ''}`}>
              Education
            </h1>
          </div>
          <div className="flex justify-center items-center flex-col">
            <div
              onClick={() => setStep(courseType == 2 ? 5 : 4)}
              className={`w-6 h-6 ${step >= (courseType == 2 ? 5 : 4) ? 'bg-green-400' : 'bg-red-400'
                } rounded-full cursor-pointer`}></div>
            <h1 className={`${step === (courseType == 2 ? 5 : 4) ? 'font-bold' : ''}`}>Progress</h1>
          </div>
          {(courseType == 2 || id) && (
            <div className="flex justify-center items-center flex-col">
              <div
                onClick={() => setStep(courseType == 2 ? 6 : 5)}
                className={`w-6 h-6 ${step >= (courseType == 2 ? 6 : 5) ? 'bg-green-400' : 'bg-red-400'
                  } rounded-full cursor-pointer`}></div>
              <h1 className={`${step === (courseType == 2 ? 6 : 5) ? 'font-bold' : ''}`}>
                Content
              </h1>
            </div>
          )}
          <div className="flex justify-center items-center flex-col">
            <div
              onClick={() => setStep(courseType == 2 ? 7 : id ? 6 : 5)}
              className={`w-6 h-6 ${step >= (courseType == 2 ? 7 : id ? 6 : 5) ? 'bg-green-400' : 'bg-red-400'
                } rounded-full cursor-pointer`}></div>
            <h1 className={`${step === (courseType == 2 ? 7 : id ? 6 : 5) ? 'font-bold' : ''}`}>
              Publish
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div id="course-Information" className={`mt-6 ${step === 1 ? '' : 'hidden'}`}>
            <div className="add-video min-h-96 w-full shadow">
              <div className="video-upload p-4">
                {id && (
                  <div className="flex justify-end">
                    <button type="submit" className="px-6 btn-primary w-auto mr-2 ml-0 mt-0">
                      Update
                    </button>
                  </div>
                )}
                <div className="flex flex-col md:flex-row">
                  <div className="md:w-1/2 w-full">
                    <div className="form-group mb-4">
                      <FormInputField
                        label={'Title'}
                        type={'text'}
                        fieldName={'title'}
                        register={register}
                        errors={errors}
                        isRequired={true}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label className="block text-sm font-medium mb-1 flex items-center gap-1">
                        Course Type
                        <div className="relative inline-block group">
                          <i className="fas fa-info-circle text-gray-400 cursor-pointer text-sm" />
                          <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-72 bg-gray-800 text-white text-xs rounded-lg p-3 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
                            <p className="font-semibold mb-1">New Course</p>
                            <p className="mb-2 text-gray-300">
                              {`Content is exclusive to this course and won't appear separately in
                              your content library or search results.`}
                            </p>
                            <p className="font-semibold mb-1">Channel Course</p>
                            <p className="text-gray-300">
                              Uses existing library content that can also appear in search results
                              and be accessed or purchased individually.
                            </p>
                            {/* Tooltip arrow */}
                            <div className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-800" />
                          </div>
                        </div>
                      </label>
                      <select
                        className="input-style"
                        {...register('type', {
                          onChange: (e) => {
                            const selectedValue = parseInt(e.target.value, 10);
                            if (selectedValue === 2) {
                              setShowError(false);
                            } else {
                              setShowError(true);
                            }
                          }
                        })}
                        disabled={!!id}>
                        <option value={0}>Select</option>
                        <option value={1}>Channel</option>
                        <option value={2}>New Course</option>
                      </select>
                    </div>
                    {(courseType == 0 || courseType == 1) && (
                      <div className="form-group mb-4">
                        <label className="block text-sm font-medium mb-1">Channel</label>
                        {finalChannels && (
                          <Controller
                            render={({
                              field: { onChange, onBlur, value, ref },
                              fieldState: { error }
                            }) => (
                              <Select
                                filterOption={customFilterOption}
                                options={finalChannels}
                                value={value}
                                id="channelId"
                                onChange={(val) => onChange(val)}
                                isLoading={channelList.length ? false : true}
                              />
                            )}
                            name="channelId"
                            control={control}
                          />
                        )}
                      </div>
                    )}
                    <div className="form-group mb-4">
                      <label className="block text-sm font-medium mb-1">Content Type</label>
                      {contentType && (
                        <Controller
                          render={({ field: { onChange, value }, fieldState: { error } }) => (
                            <>
                              <Select
                                filterOption={customFilterOption}
                                options={finalContent}
                                value={value}
                                id="contentTypes"
                                onChange={(val) => onChange(val)}
                                isLoading={contentType.length ? false : true}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    borderColor: error ? 'red' : base.borderColor,
                                  }),
                                }}
                              />
                              {error && <span className="text-red-500 text-xs">{error.message}</span>}
                            </>
                          )}
                          name="contentTypes"
                          control={control}
                        // rules={{
                        //   validate: (value) =>
                        //     (value && value.value) ? true : 'Content Type is required',
                        // }}
                        />
                      )}
                    </div>
                    {courseType == 2 && (
                      <>
                        <div className="form-group mb-4">
                          <label className="block text-sm font-medium mb-1">Categories</label>
                          {categoriesList && (
                            <Controller
                              render={({ field: { onChange, value }, fieldState: { error } }) => (
                                <>
                                  <Select
                                    options={
                                      categoriesList &&
                                      categoriesList.categories?.map((category) => ({
                                        value: category.id,
                                        label: category.category,
                                      }))
                                    }
                                    value={value}
                                    filterOption={customFilterOption}
                                    id="categories"
                                    onChange={(val) => onChange(val)}
                                    isMulti
                                    isLoading={Object.keys(categoriesList).length ? false : true}
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        borderColor: error ? 'red' : base.borderColor,
                                      }),
                                    }}
                                  />
                                  {error && <span className="text-red-500 text-xs">{error.message}</span>}
                                </>
                              )}
                              name="categories"
                              control={control}
                            // rules={{
                            //   validate: (value) =>
                            //     (value && value.length > 0) ? true : 'At least one Category is required',
                            // }}
                            />
                          )}
                        </div>
                        <div className="form-group mb-4">
                          <label className="block text-sm font-medium mb-1">Speaker</label>
                          {speakers && (
                            <Controller
                              render={({
                                field: { onChange, onBlur, value, ref },
                                fieldState: { error }
                              }) => (
                                <Select
                                  options={finalSpeaker}
                                  value={value}
                                  className="w-full mr-2"
                                  filterOption={customFilterOption}
                                  id="speakers"
                                  isMulti
                                  onChange={(val) => onChange(val)}
                                  isLoading={speakers.length ? false : true}
                                />
                              )}
                              name="speakers"
                              control={control}
                            />
                          )}
                          <button
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#AddSpeakerModal"
                            className="px-6 btn-primary w-auto whitespace-nowrap mr-2 ml-0 mt-2">
                            <i className="fas fa-plus pr-1"></i> Add
                          </button>
                        </div>
                      </>
                    )}
                  </div>

                  {id && (
                    <div className="form-group mb-4 md:hidden">
                      <label className="block text-sm font-medium mb-1">Course Thumbnail</label>
                      <div className="relative w-full overflow-hidden" style={{ aspectRatio: '16 / 9' }}>
                        <img
                          src={singleCourse && singleCourse.thumbnailUrl}
                          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                        <div className="flex flex-wrap justify-center items-center pb-4 rounded-b-md absolute inset-0 btns-main">
                          <button
                            data-bs-toggle="modal"
                            data-bs-target="#uploadCourseThumbnail"
                            type="button"
                            className="mx-0 px-6 btn-primary w-28 mt-0 mr-2">
                            Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {id && (
                    <div className="form-group thumbnail-main ml-7 hidden md:block">
                      <label className="block text-sm font-medium mb-1">Course Thumbnail</label>
                      <div className="relative thumb-wrap">
                        <img
                          src={singleCourse && singleCourse.thumbnailUrl}
                          style={{ aspectRatio: '16 / 9' }}
                        />
                        <div className="flex flex-wrap justify-center items-center pb-4 rounded-b-md absolute inset-0 btns-main">
                          <button
                            data-bs-toggle="modal"
                            data-bs-target="#uploadCourseThumbnail"
                            type="button"
                            className="mx-0 px-6 btn-primary w-28 mt-0 mr-2">
                            Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className={`form-group mb-4 ${id ? '' : 'md:w-1/2'} w-full`}>
                  <label className="block text-sm font-medium mb-1">Description</label>
                  <Editor
                    editorState={editorState}
                    setEditorState={(newState) => {
                      setEditorState(newState);
                      setIsEditorDirty(true);
                    }}
                  />
                </div>
                {showError && (
                  <span className="text-red-500 text-xs flex item-center error">
                    Please Select Channel
                  </span>
                )}
                <div className={`flex items-center mt-6 justify-end ${id ? '' : ''}`}>
                  {courseType == 2 && !id ? (
                    <button type="submit" className="mx-0 px-6 btn-primary w-auto mt-0">
                      Save
                    </button>
                  ) : (
                    <button
                      onClick={handleNextClick}
                      type="button"
                      className="mx-0 px-6 btn-primary w-auto mt-0">
                      Next
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {courseType == 2 && (
            <div id="header-image" className={`mt-6 ${step === 2 ? '' : 'hidden'}`}>
              <div className="add-video min-h-96 w-full shadow">
                <div className="video-upload p-4">
                  <div className="form-group thumbnail-main">
                    <label className="block text-sm font-medium mb-1">
                      Header Background Image
                    </label>
                    <div className="relative thumb-wrap">
                      <img
                        src={singleCourse && singleCourse.headerBackgroundImageUrl}
                        style={{ width: '1400px', height: '400px', objectFit: 'cover' }}
                      />
                      <div className="flex flex-wrap justify-center items-center pb-4 rounded-b-md absolute inset-0 btns-main">
                        <button
                          data-bs-toggle="modal"
                          data-bs-target="#uploadHeaderBackground"
                          type="button"
                          className="mx-0 px-6 btn-primary w-28 mt-0 mr-2">
                          Upload
                        </button>
                      </div>
                    </div>
                    <small>Recommended Size: 1400x400px</small>
                  </div>
                  <div className="flex items-center mt-6 justify-between">
                    <button
                      onClick={handlePreviousClick}
                      type="button"
                      className="px-6 btn-primary w-auto mr-2 ml-0 mt-0">
                      Previous
                    </button>
                    <button
                      onClick={handleNextClick}
                      type="button"
                      className="mx-0 px-6 btn-primary w-auto mt-0">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div
            id="pricing"
            className={`mt-6 ${step === (courseType == 2 ? 3 : 2) ? '' : 'hidden'}`}>
            <div className="add-video min-h-96 w-full shadow">
              <div className="video-upload p-4">
                <div className="flex justify-end">
                  <button type="submit" className="px-6 btn-primary w-auto mr-2 ml-0 mt-0">
                    Update
                  </button>
                </div>
                <div className="video-upload lg:w-3/5">
                  {courseType == 1 ? (
                    <>
                      <div className="form-group mb-4">
                        <label className="block text-sm font-medium mb-1">Price</label>
                        <input
                          className={`input-style ${inheritPrice ? 'bg-gray-300' : ''}`}
                          disabled={inheritPrice}
                          type="text"
                          id="price"
                          {...register('price')}
                        />
                      </div>
                      <div className="form-group mb-4">
                        <label className="block text-sm font-medium mb-1">
                          Inherit from Channel
                        </label>
                        <div className="form-check form-switch pl-0 mr-3 relative">
                          <input
                            className="form-check-input switch-btn"
                            type="checkbox"
                            role="switch"
                            id="inheritPrice"
                            {...register('inheritPrice')}
                          />
                          <i className="fas fa-check checkbox-tick hidden"></i>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="lg:grid lg:grid-cols-3 gap-4">
                        <div className="form-group mb-4 w-full">
                          <label className="block text-sm font-medium mb-1">
                            Access Type <span className="text-red-500">*</span>
                          </label>
                          <select
                            className="border input-style"
                            id="accessType"
                            {...register('accessType')}>
                            <option value={0}>Select</option>
                            <option value={1}>Paid</option>
                            <option value={2}>Free</option>
                            <option value={3}>Locked</option>
                          </select>
                        </div>

                        <div className="flex items-center">
                          <div className="form-group mb-4 w-full">
                            <label className="block text-sm font-medium mb-1">Price</label>
                            <input
                              disabled={watch('accessType') == 3 || watch('accessType') == 2}
                              className="input-style"
                              type="text"
                              id="price"
                              {...register('price')}
                            />
                          </div>
                        </div>

                        {productAccess.secondaryPaymentGateway && (
                          <div className="form-group mb-4">
                            <label className="block text-sm font-medium mb-1">
                              Payment Gateway
                            </label>
                            <select
                              className="border input-style"
                              id="isSecondaryPaymentGateway"
                              value={paymentGateway}
                              onChange={(e) => setPaymentGateway(e.target.value)}>
                              <option value="Primary">Primary</option>
                              <option value="Secondary">Secondary</option>
                            </select>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className="flex items-center mt-10 justify-between">
                  <button
                    onClick={handlePreviousClick}
                    type="button"
                    className="px-6 btn-primary w-auto mr-2 ml-0 mt-0">
                    Previous
                  </button>
                  <button
                    onClick={handleNextClick}
                    type="button"
                    className="mx-0 px-6 btn-primary w-auto mt-0">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            id="education"
            className={`mt-6 ${step === (courseType == 2 ? 4 : 3) ? '' : 'hidden'}`}>
            <div className="add-video min-h-96 w-full shadow">
              <div className="video-upload p-4">
                {id && (
                  <div className="flex justify-end">
                    <button type="submit" className="px-6 btn-primary w-auto mr-2 ml-0 mt-0">
                      Update
                    </button>
                  </div>
                )}
                <div className="video-upload lg:w-3/5">
                  <div className="form-group mb-4">
                    <FormInputField
                      label={'CE Credits'}
                      type={'text'}
                      fieldName={'points'}
                      register={register}
                      errors={errors}
                      isRequired={false}
                    />
                  </div>
                  <div className="form-group mb-4">
                    <label className="block text-sm font-medium mb-1">Credit Type</label>
                    {courseCreditType && (
                      <Controller
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                          <Select
                            options={courseCreditType.map((item) => {
                              return {
                                value: item.id,
                                label: item.type
                              };
                            })}
                            filterOption={customFilterOption}
                            value={value}
                            id="creditTypes"
                            isMulti
                            onChange={(val) => onChange(val)}
                          />
                        )}
                        name="creditTypes"
                        control={control}
                      />
                    )}
                  </div>
                  <div className="form-group mb-4">
                    <label className="block text-sm font-medium mb-1">Module</label>
                    {courseModule && (
                      <Controller
                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                          <Select
                            options={courseModule.map((item) => {
                              return {
                                value: item.id,
                                label: item.module
                              };
                            })}
                            filterOption={customFilterOption}
                            value={value}
                            id="modules"
                            isMulti
                            onChange={(val) => onChange(val)}
                          />
                        )}
                        name="modules"
                        control={control}
                      />
                    )}
                  </div>
                  <div className="form-group mb-4">
                    <label className="block text-sm font-medium mb-1">
                      Completion Requirements
                    </label>
                    <select className="input-style" {...register('courseCompletionType')}>
                      <option value={0}>Select</option>
                      <option value={1}>Quiz Completion</option>
                      <option value={2}>Video Completion</option>
                    </select>
                  </div>
                  <div className="form-group mb-4">
                    <FormInputField
                      label={'Pass Rate'}
                      type={'text'}
                      fieldName={'courseCompletionPercentage'}
                      register={register}
                      errors={errors}
                      isRequired={false}
                    />
                  </div>
                  <div className={`form-group mb-3 flex gap-6`}>
                    <div className="w-1/2">
                      <label>Number of Attempts</label>
                      <select
                        className="input-style"
                        {...register('numberOfAttempts')}
                        disabled={completionRequirement == 2 ? true : false}>
                        <option value="">Select Attempts</option>
                        {[...Array(10)].map((_, idx) => (
                          <option key={idx + 1} value={idx + 1}>
                            {idx + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="w-1/2">
                      <label>Credit Value if Fail (%)</label>
                      <select
                        className="input-style"
                        {...register('creditValueIfFail')}
                        defaultValue=""
                        disabled={completionRequirement == 2 ? true : false}>
                        <option value="">Select %</option>
                        {[...Array(21)].map((_, idx) => {
                          const percent = idx * 5;
                          const formattedPercent = percent.toFixed(2);
                          return (
                            <option key={percent} value={formattedPercent}>
                              {percent}%
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="flex items-center mt-6 justify-between">
                  <button
                    onClick={handlePreviousClick}
                    type="button"
                    className="px-6 btn-primary w-auto mr-2 ml-0 mt-0">
                    Previous
                  </button>
                  <button
                    onClick={handleNextClick}
                    type="button"
                    className="mx-0 px-6 btn-primary w-auto mt-0">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            id="progress"
            className={`mt-6 ${step === (courseType == 2 ? 5 : 4) ? '' : 'hidden'}`}>
            <div className="add-video min-h-96 w-full shadow">
              <div className="video-upload p-4">
                {id && (
                  <div className="flex justify-end">
                    <button type="submit" className="px-6 btn-primary w-auto mr-2 ml-0 mt-0">
                      Update
                    </button>
                  </div>
                )}
                <div className="video-upload lg:w-3/5">
                  <div className="form-group mb-4">
                    <label className="block text-sm font-medium mb-1">
                      Display Course Progress
                    </label>
                    <div className="form-check form-switch pl-0 mr-3 relative">
                      <input
                        className="form-check-input switch-btn"
                        type="checkbox"
                        role="switch"
                        id="displayCourseProgress"
                        {...register('displayCourseProgress')}
                      />
                      <i className="fas fa-check checkbox-tick hidden"></i>
                    </div>
                  </div>
                  <div className="form-group mb-4 mt-10">
                    <label className="block text-sm font-medium mb-1">Show Course Completion</label>
                    <div className="form-check form-switch pl-0 mr-3 relative">
                      <input
                        className="form-check-input switch-btn"
                        type="checkbox"
                        role="switch"
                        id="showCourseCompletion"
                        {...register('showCourseCompletion')}
                      />
                      <i className="fas fa-check checkbox-tick hidden"></i>
                    </div>
                  </div>
                  <div className="form-group mb-4 mt-10">
                    <label className="block text-sm font-medium mb-1">
                      Must complete each Lesson before Progressing
                    </label>
                    <div className="form-check form-switch pl-0 mr-3 relative">
                      <input
                        className="form-check-input switch-btn"
                        type="checkbox"
                        role="switch"
                        id="mustCompleteVideos"
                        {...register('mustCompleteVideos')}
                      />
                      <i className="fas fa-check checkbox-tick hidden"></i>
                    </div>
                  </div>
                  <div className="flex items-center space-x-6 mt-10">
                    <div className="form-group">
                      <label className="block text-sm font-medium mb-1">
                        Certificate on completion
                      </label>
                      <div className="form-check form-switch pl-0 mr-3 relative">
                        <input
                          className="form-check-input switch-btn"
                          type="checkbox"
                          role="switch"
                          id="withCertificate"
                          {...register('withCertificate')}
                        />
                        <i className="fas fa-check checkbox-tick hidden"></i>
                      </div>
                    </div>

                    {/* Certificate template select dropdown */}
                    {watchCertificate && (
                      <div className="form-group">
                        <label className="block text-sm font-medium mb-1">
                          Certificate Template
                        </label>
                        <select
                          className="input-style w-96"
                          {...register('certificatetemplateid')}
                          value={selectedCertificateTemplate}
                          onChange={(e) => setSelectedCertificateTemplate(e.target.value)}>
                          {certificateTemplates?.map((method, idx) => (
                            <option value={method.certificateId} key={idx}>
                              {method.certificateTemplateName}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>

                  <div className="form-group mb-4 mt-10">
                    <FormInputField
                      label={'External Link'}
                      type={'text'}
                      fieldName={'externalLink'}
                      register={register}
                      errors={errors}
                      isRequired={false}
                    />
                  </div>
                  <div className="form-group mb-4">
                    <label className="block mb-1">Course Completion Message</label>
                    <textarea
                      className="input-style"
                      {...register('courseCompletionMessage')}
                      rows={3}></textarea>
                  </div>
                </div>
                <div className="flex items-center mt-6 justify-between">
                  <button
                    onClick={handlePreviousClick}
                    type="button"
                    className="px-6 btn-primary w-auto mr-2 ml-0 mt-0">
                    Previous
                  </button>
                  <button
                    onClick={handleNextClick}
                    type="button"
                    className="mx-0 px-6 btn-primary w-auto mt-0">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
          {(courseType == 2 || id) && (
            <div
              id="content"
              className={`mt-6 ${step === (courseType == 2 ? 6 : 5) ? '' : 'hidden'}`}>
              <div className="add-video min-h-96 w-full shadow">
                <div className="video-upload p-4">
                  <Content
                    newChannelId={newChannelId}
                    type={courseType}
                    setChapterAddFlag={setChapterAddFlag}
                  />
                  <div className="flex items-center mt-6 justify-between">
                    <button
                      onClick={handlePreviousClick}
                      type="button"
                      className="px-6 btn-primary w-auto mr-2 ml-0 mt-0">
                      Previous
                    </button>
                    <button
                      onClick={handleNextClick}
                      type="button"
                      className="mx-0 px-6 btn-primary w-auto mt-0">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div
            id="publish"
            className={`mt-6 ${step === (courseType == 2 ? 7 : id ? 6 : 5) ? '' : 'hidden'}`}>
            <div className="add-video min-h-96 w-full shadow">
              <div className="video-upload p-4">
                <div className="video-upload lg:w-3/5">
                  <div className="form-group mb-4">
                    <label className="block text-sm font-medium mb-1">Publish Status</label>
                    <div>
                      <div className="flex items-center">
                        <div className="form-check">
                          <input
                            className="form-check-input radio-btn"
                            type="radio"
                            name="channelType"
                            value={publishStatus}
                            onChange={() => setPublishStatus(1)}
                            checked={publishStatus === 1 ? true : false}
                          />
                          <label className="w-16" htmlFor="paid">
                            Draft
                          </label>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="form-check">
                          <input
                            className="form-check-input radio-btn"
                            type="radio"
                            name="channelType"
                            value={publishStatus}
                            onChange={() => setPublishStatus(2)}
                            checked={publishStatus === 2 ? true : false}
                          />
                          <label className="w-16" htmlFor="free">
                            Online
                          </label>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="form-check">
                          <input
                            className="form-check-input radio-btn"
                            type="radio"
                            name="channelType"
                            value={publishStatus}
                            onChange={() => setPublishStatus(3)}
                            checked={publishStatus === 3 ? true : false}
                          />
                          <label className="w-16" htmlFor="locked">
                            Offline
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {id && (
                    <div className="form-group mt-6">
                      <label className="block text-sm font-medium mb-1">Course URL</label>
                      <div className="flex items-center gap-2">
                        <input
                          type="text"
                          readOnly
                          value={singleCourse.courseUrl}
                          className="input-style flex-1 bg-gray-50 text-gray-600 cursor-default"
                          onFocus={(e) => e.target.select()}
                        />
                        <button
                          type="button"
                          onClick={handleCopyUrl}
                          title="Copy link"
                          className="px-3 py-2 btn-primary w-auto mt-0 whitespace-nowrap">
                          {copiedUrl ? (
                            <><i className="fas fa-check pr-1"></i> Copied!</>
                          ) : (
                            <><i className="fas fa-copy pr-1"></i> Copy</>
                          )}
                        </button>
                        <a
                          href={singleCourse.courseUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Preview course"
                          className="px-3 py-2 btn-primary w-auto mt-0 whitespace-nowrap">
                          <i className="fas fa-external-link-alt pr-1"></i> Preview
                        </a>
                      </div>
                      <p className="text-xs text-gray-400 mt-1">
                        Share this link so learners can access the course directly.
                      </p>
                    </div>
                  )}
                </div>
                <div className="flex items-center mt-6 justify-between">
                  <button
                    onClick={handlePreviousClick}
                    type="button"
                    className="px-6 btn-primary w-auto mr-2 ml-0 mt-0">
                    Previous
                  </button>
                  <button type="submit" className="mx-0 px-6 btn-primary w-auto mt-0">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </>
      <UploadThumbnail courseId={id} />
      <UploadThumbnail
        courseId={id}
        modalId="uploadHeaderBackground"
        uploadUrl={`v2/courses/upload/headerbackground/${id}?`}
      />
      <AddSpeaker setSelectedSpeakerName={setSelectedSpeakerName} />
      <AddChapterModel chapterAddFlag={chapterAddFlag} setChapterAddFlag={setChapterAddFlag} />
    </div>
  );
};

export default CourseTab;
